import { Component, ojs, app } from "modular-openscriptjs";
import { cleanDispose, eParse } from "../helpers";
import { tool } from "../fotastart";
import ModalComponent from "./ModalComponent";
import { gc } from "../ojs.contexts";

const h = app("h");

export default class GlobalModal extends ModalComponent {
	name = "GlobalModal";
	
	$$app = {
		indicator: {
			process: {
				start: (ed, event) => this.showModal(ed),
				end: (ed, event) => this.closeModal(ed),
			},
		},
	};

	$$ojs = {
		routeChanged: () => {
			this.closeModal();
		},
	};

	$$user = {
		needs: {
			profileModal: () => this.showUserProfileModal(),
		},
	};

	showModal(ed) {
		if (
			gc.loadingModal !== null &&
			typeof gc.loadingModal !== "undefined" &&
			gc.loadingModal._isShown
		)
			return;

		if (gc.loadingModal) {
			cleanDispose(gc.loadingModal);
		}

		let title = "On it...";
		let type = "dots";
		let d = eParse(ed);

		if (ed) {
			title = d.message.get("title", "On it...");
			type = d.message.get("type", "dots");
		}

		gc.loadingModal = tool.plainModal(
			h.div(
				{
					class: "modal-content",
				},
				h.div(
					{
						class: `modal-header border-0`,
					},

					h.h5(
						{
							class: "modal-title",
						},
						title
					)
				),
				h.div(
					{
						class: "modal-body",
					},
					h.Loader(type)
				)
			),
			{ data_bs_backdrop: "static", style: "z-index: 1220;" }
		);

		gc.loadingModal?.show();
	}

	closeModal() {
		setTimeout(() => {
			gc?.loadingModal?.hide();
		}, 1500);
	}

	showUserProfileModal() {
		let options = new tool.ModalOptions();
		options.buttons.right.visible = false;
		options.buttons.left.visible = true;

		tool.modal("Update your Profile", h.EditProfile(gc.user), options);
	}

	cleanUp() {
		super.cleanUp();
		cleanDispose(gc.loadingModal);
	}
}

